import { render } from "./MtnGhanaTerms.vue?vue&type=template&id=d5f7d85e&scoped=true"
import script from "./MtnGhanaTerms.vue?vue&type=script&lang=js"
export * from "./MtnGhanaTerms.vue?vue&type=script&lang=js"

import "./MtnGhanaTerms.vue?vue&type=style&index=0&id=d5f7d85e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5f7d85e"]])

export default __exports__